export default "dist/images/components-design-separator-control-rounded-2.6e57ec5.png";